<template>
  <modal v-if="locales.length" :adaptive="true" :width="420" height="auto" name="language">
    <div class="py-4 px-8 flex flex-col body-font">
      <h3 class="text-center font-bold mb-6 text-lg main-font">{{ $t("languages.generic") }}</h3>

      <div
        v-for="lang in locales"
        :key="lang"
        :class="{ 'primary-background text-white': locale === lang }"
        class="w-full mb-2 rounded-lg px-6 py-4 transition-all duration-200 primary-background-active-hover cursor-pointer flex flex-row justify-between items-center"
        @click="selectLocale(lang)"
      >
        <p class="text-base font-semibold">{{ labels[lang] || lang }}</p>
      </div>

      <div class="flex justify-between items-center mt-4">
        <div></div>
        <secondary-button @click="$modal.hide('language')">{{ $t("cancel.generic") }}</secondary-button>
      </div>
    </div>
  </modal>
</template>

<script>
import SecondaryButton from "@/components/ui-kit/buttons/SecondaryButton";
import StorageClient from "@/services/storageClient";
import { mapState } from "vuex";
import authClient from "@/services/authClient";
import { ALLOWED_LOCALES, LOCALE_LABELS } from "@/utils/allowedLocales";

export default {
  name: "LanguageModal",
  components: { SecondaryButton },
  data() {
    return {
      locales: ALLOWED_LOCALES,
      labels: LOCALE_LABELS
    };
  },
  computed: {
    ...mapState("locale", ["locale"])
  },
  methods: {
    async selectLocale(lang) {
      StorageClient.setLanguage(lang);
      await authClient.updateProfileLanguage(lang);

      this.$router.go(0);
    }
  }
};
</script>

<style scoped></style>
